// extracted by css-extract-rspack-plugin
export default {"clearAction":"Al19wZrvoTQawGiJ","clearActionButton":"pEfoAn0oYBoSRN7U","clearActionLabel":"mHN4d9shiYQBQFj9"};